import type { GridColumnVisibilityModel } from '@mui/x-data-grid';
import { useContext, useMemo } from 'react';

import { TableContext, useTableStore } from '../store/store';

export const useGetData = () => {
  const { data, columns } = useContext(TableContext);
  const { searchQuery } = useTableStore();

  const filteredData = useMemo(() => {
    if (!searchQuery) return data;
    return data.filter((row) =>
      Object.entries(row).some(
        ([key, field]) =>
          columns.find((cl) => cl.field === key) &&
          String(field).toLowerCase().includes(searchQuery),
      ),
    );
  }, [columns, data, searchQuery]);

  const columnVisibilityModel = useMemo(
    (): GridColumnVisibilityModel =>
      columns.reduce(
        (obj, cl) =>
          cl.hidden
            ? {
                ...obj,
                [cl.field]: false,
              }
            : obj,
        {},
      ),
    [columns],
  );

  return { data: filteredData, columnVisibilityModel };
};
